import { render, staticRenderFns } from "./layoutHeader.vue?vue&type=template&id=acc54a2a&scoped=true&"
import script from "./layoutHeader.vue?vue&type=script&lang=js&"
export * from "./layoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./layoutHeader.vue?vue&type=style&index=0&id=acc54a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc54a2a",
  null
  
)

export default component.exports